import PrepayTermsModal from './PrepayTermsModal';

export default PrepayTermsModal;
